import { render, staticRenderFns } from "./PscInspection.vue?vue&type=template&id=ec499906&scoped=true&"
import script from "./PscInspection.vue?vue&type=script&lang=js&"
export * from "./PscInspection.vue?vue&type=script&lang=js&"
import style0 from "./PscInspection.vue?vue&type=style&index=0&id=ec499906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec499906",
  null
  
)

export default component.exports